/**
 * SVG Icon Components for PocketFiler
 * All icons are sourced from /public/assets/ SVG pack
 * Usage: Import and use as React components with className for sizing and color
 */

import React from 'react';

// Base icon wrapper component
const SvgIcon = ({ src, alt = '', className = 'h-5 w-5', ...props }) => (
  <img 
    src={`/assets/${src}`} 
    alt={alt} 
    className={className}
    aria-hidden={!alt}
    {...props}
  />
);

// Navigation Icons
export const IconDashboard = ({ className }) => <SvgIcon src="chart.svg" className={className} />;
export const IconOffice = ({ className }) => <SvgIcon src="organization.svg" className={className} />;
export const IconClient = ({ className }) => <SvgIcon src="user.svg" className={className} />;
export const IconDeal = ({ className }) => <SvgIcon src="briefcase.svg" className={className} />;
export const IconChat = ({ className }) => <SvgIcon src="chat.svg" className={className} />;
export const IconDocument = ({ className }) => <SvgIcon src="clipboard.svg" className={className} />;
export const IconSettings = ({ className }) => <SvgIcon src="filter.svg" className={className} />;
export const IconFolder = ({ className }) => <SvgIcon src="folder.svg" className={className} />;

// Status Icons
export const IconCheck = ({ className }) => <SvgIcon src="goal.svg" className={className} />;
export const IconWarning = ({ className }) => <SvgIcon src="monitoring.svg" className={className} />;
export const IconClock = ({ className }) => <SvgIcon src="clock.svg" className={className} />;
export const IconShield = ({ className }) => <SvgIcon src="shield.svg" className={className} />;
export const IconTarget = ({ className }) => <SvgIcon src="target.svg" className={className} />;

// AI / Automation Icons
export const IconAI = ({ className }) => <SvgIcon src="bulb.svg" className={className} />;
export const IconAnalysis = ({ className }) => <SvgIcon src="analysis.svg" className={className} />;
export const IconResearch = ({ className }) => <SvgIcon src="research.svg" className={className} />;

// Action Icons
export const IconPlanning = ({ className }) => <SvgIcon src="planning.svg" className={className} />;
export const IconTask = ({ className }) => <SvgIcon src="task.svg" className={className} />;
export const IconSchedule = ({ className }) => <SvgIcon src="schedule.svg" className={className} />;
export const IconGrowth = ({ className }) => <SvgIcon src="growth.svg" className={className} />;
export const IconPerformance = ({ className }) => <SvgIcon src="performance.svg" className={className} />;
export const IconProductivity = ({ className }) => <SvgIcon src="productivity.svg" className={className} />;

// Communication Icons
export const IconDiscussion = ({ className }) => <SvgIcon src="discussion.svg" className={className} />;
export const IconPhoneCall = ({ className }) => <SvgIcon src="phone call.svg" className={className} />;
export const IconBell = ({ className }) => <SvgIcon src="bell.svg" className={className} />;
export const IconNetwork = ({ className }) => <SvgIcon src="network.svg" className={className} />;

// Business Icons
export const IconBriefcase = ({ className }) => <SvgIcon src="briefcase.svg" className={className} />;
export const IconStartup = ({ className }) => <SvgIcon src="startup.svg" className={className} />;
export const IconAward = ({ className }) => <SvgIcon src="award.svg" className={className} />;
export const IconTrophy = ({ className }) => <SvgIcon src="trophy.svg" className={className} />;
export const IconCoin = ({ className }) => <SvgIcon src="coin.svg" className={className} />;
export const IconRate = ({ className }) => <SvgIcon src="rate.svg" className={className} />;

// Time Icons
export const IconHourglass = ({ className }) => <SvgIcon src="hourglass.svg" className={className} />;
export const IconDeadline = ({ className }) => <SvgIcon src="deadline.svg" className={className} />;
export const IconSaveTime = ({ className }) => <SvgIcon src="save time.svg" className={className} />;
export const IconTimeManagement = ({ className }) => <SvgIcon src="time management.svg" className={className} />;
export const IconWorkingTime = ({ className }) => <SvgIcon src="working time.svg" className={className} />;

// Misc Icons
export const IconVision = ({ className }) => <SvgIcon src="vision.svg" className={className} />;
export const IconObjective = ({ className }) => <SvgIcon src="objective.svg" className={className} />;
export const IconSolution = ({ className }) => <SvgIcon src="solution.svg" className={className} />;
export const IconProtection = ({ className }) => <SvgIcon src="protection.svg" className={className} />;
export const IconImprovement = ({ className }) => <SvgIcon src="improvement.svg" className={className} />;
export const IconEnergy = ({ className }) => <SvgIcon src="energy.svg" className={className} />;
export const IconWorking = ({ className }) => <SvgIcon src="working.svg" className={className} />;

// Generic SVG icon for custom paths
export const CustomSvgIcon = ({ src, className = 'h-5 w-5', alt = '' }) => (
  <SvgIcon src={src} className={className} alt={alt} />
);

export default {
  IconDashboard,
  IconOffice,
  IconClient,
  IconDeal,
  IconChat,
  IconDocument,
  IconSettings,
  IconFolder,
  IconCheck,
  IconWarning,
  IconClock,
  IconShield,
  IconTarget,
  IconAI,
  IconAnalysis,
  IconResearch,
  IconPlanning,
  IconTask,
  IconSchedule,
  IconGrowth,
  IconPerformance,
  IconProductivity,
  IconDiscussion,
  IconPhoneCall,
  IconBell,
  IconNetwork,
  IconBriefcase,
  IconStartup,
  IconAward,
  IconTrophy,
  IconCoin,
  IconRate,
  IconHourglass,
  IconDeadline,
  IconSaveTime,
  IconTimeManagement,
  IconWorkingTime,
  IconVision,
  IconObjective,
  IconSolution,
  IconProtection,
  IconImprovement,
  IconEnergy,
  IconWorking,
  CustomSvgIcon
};
